export class InvalidNifError extends Error {
	constructor() {
		super('invalid_nif');
	}
}
